import { styled } from "goober";
import { usePanelTransition } from "./PanelTransition";
import { PanelHeader, PanelHeaderNavigation } from "./PanelHeader";
import { useMakeUrl } from "../lib/urls";
import { ResponsiveTabs } from "./ResponsiveTabs";
import { StepPill } from "./StepPill";
import { stepTabs, type StepTab } from "./stepTab";

const Navigation = styled(PanelHeaderNavigation)`
  min-width: 148px;
`;

type Props = {
  step: { name: string; color: string };
  right?: React.ReactNode;
  backTo: string;
  tab: StepTab;
  browserApplicable: boolean;
  onNavigate?: () => void;
};

export function StepHeader({
  step,
  right,
  backTo,
  tab,
  browserApplicable,
  onNavigate,
}: Props) {
  const direction = usePanelTransition();
  const makeUrl = useMakeUrl();
  return (
    <PanelHeader>
      <Navigation data-nav-enter={direction}>
        <StepPill step={step} to={backTo} onNavigate={onNavigate} />
        <ResponsiveTabs
          label="Step views"
          activeKey={tab}
          items={stepTabs
            .filter((item) => item.key !== "browser" || browserApplicable)
            .map((item) => ({
              ...item,
              to: makeUrl(null, { stepTab: item.key, showRuns: "" }),
              shortcut:
                "shortcut" in item
                  ? `Meta+Shift+${item.shortcut} Control+Shift+${item.shortcut}`
                  : undefined,
              onSelect: onNavigate,
            }))}
        />
      </Navigation>
      {right}
    </PanelHeader>
  );
}
